import React, { useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import ImagesContext from "../../ImagesContext";
import Card from "../Card/Card";
import "./Selector.css";

export default function Selector({ setLocation, setTemplateData }) {
  const images = useContext(ImagesContext);
  let history = useHistory();
  let location = useLocation();
  useEffect(() => {
    setLocation(location.pathname);
  });

  const cardOptions = [
    {
      banner: "illustration1",
      src: images.illustration1,
      altText:
        "background option 1: a patterned background in thoughtworks brand colors",
      logo: images.fbLogo1,
    },
    {
      banner: "illustration2",
      src: images.illustration2,
      altText:
        "background option 2: a patterned background in thoughtworks brand colors",
      logo: images.fbLogo2,
    },
    {
      banner: "illustration3",
      src: images.illustration3,
      altText:
        "background option 3: a patterned background in thoughtworks brand colors",
      logo: images.fbLogo3,
    },
    {
      banner: "illustration4",
      src: images.illustration4,
      altText:
        "background option 4:a patterned background in thoughtworks brand colors",
      logo: images.fbLogo4,
    },
    {
      banner: "illustration5",
      src: images.illustration5,
      altText:
        "background option 5: a patterned background in thoughtworks brand colors",
      logo: images.fbLogo5,
    },
    {
      banner: "illustration6",
      src: images.illustration6,
      altText:
        "background option 6: a patterned background in thoughtworks brand colors",
      logo: images.fbLogo6,
    },
  ];

  const loadTemplate = (e, imgSrc, logo, templateType, banner) => {
    e.preventDefault();
    setTemplateData({
      banner: banner,
      logo: logo,
      type: templateType,
      imgSrc: imgSrc,
    });
    history.push("/template");
  };

  return (
    <div className="main-area">
      <div className="selector">
        <div className="title">
          <h1>Choose your template:</h1>
        </div>
        <h2>Horizontal</h2>
        <div className="card-container">
          {cardOptions.map((option) => {
            return (
              <Card
                templateType="main"
                imgSrc={option.src}
                altText={option.altText}
                onClick={loadTemplate}
                banner={option.banner}
                logo={option.logo}
                key={option.banner}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

Selector.propTypes = {
  setLocation: PropTypes.func,
  setTemplateData: PropTypes.func,
};
